import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { Badge, Card, Form, Label, Spinner } from "reactstrap";
import { verifyAPI } from "../../api/index";
import { createMenuAPI, getMenuListAPI, updateMenuAPI, updateMenuStatusAPI } from "../../api/menu";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import CKEditor from "../../myComponents/CK Editor/Index";
import MyDataTable from "../../myComponents/DataTable/MyDataTable";
import ConfirmModal from "../../myComponents/modals/ConfirmModal";
import Required from "../../myComponents/validate/Required";
import { decrypt, encrypt } from "../../utils/Encrypt";
import useLogout from "../../hooks/useLogout";
import CkEditor from "../../myComponents/CK Editor/Index";
const ManageMenu = () => {
  const navigate = useNavigate();
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  // state to store response true or false of CK_Editor
  const [isCKEditor, setIsCKEditor] = useState(true);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const [column, setColumn] = useState([
    {
      name: "Menu",
      selector: (row) => (
        <div>
          <p>{row?.menu}</p>
          <p>{row?.hn_menu}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Page Title",
      selector: (row) => (
        <div>
          <p>{row?.page_title}</p>
          <p>{row?.hn_page_title}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Page Type",
      selector: (row) => (
        <div>
          <p>{row?.page_type}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Page URL",
      selector: (row) => (
        <div>
          <p>{row?.page_url}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Page Content",
      selector: (row) => (
        <div>
          <p>
            {
              //  <DynamicCKEditorUpdater instanceName="page" rowKey={row?.description} />
            }
          </p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Page Content Hindi",
      selector: (row) => (
        <div>
          <p>
            {" "}
            {
              //  <DynamicCKEditorUpdater instanceName="pagehn" rowKey={row?.hn_description} />
            }
          </p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Order",
      selector: (row) => (
        <div>
          <p> {<p>{row?.order}</p>}</p>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row?.status ? "success" : "danger"}`}>{row?.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button
            outline
            color={`warning`}
            size={`xs`}
            className={`mx-1`}
            onClick={() => handleEdit(row)}
            data-toggle="tooltip"
            data-placement="top"
            title="Edit Menu"
            disabled={row?.menu == "Home"}
          >
            {" "}
            <Icon name="edit"></Icon>
          </Button>
          <Button
            outline
            color="primary"
            size="xs"
            onClick={() => handleSubMenuClick(row)}
            data-toggle="tooltip"
            data-placement="top"
            title="Add new Sub Menu"
          >
            <Icon name="plus"></Icon>
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  const handleSubMenuClick = (row) => {
    navigate("/manage-sub-menu", { state: { row, mode: "Add" } });
  };
const handleEdit = (row) => {
  window.scrollTo(0, 0);

  setMode("Edit");
  setIsOpen(true);

  setValue("haveSubMenu", row?.submenu);
  setValue("id", row?.id);
  setValue("rowData", row?.row);
  setValue("menu", row?.menu);
  setValue("menu_hn", row?.hn_menu);
  setValue("page_title", row?.page_title);
  setValue("order", row?.order);
  setValue("hn_page_title", row?.hn_page_title);
  setValue("page_url", row?.page_url?.split("/").pop());

  setValue(
    "status",
    row?.status
      ? { label: "Active", value: true }
      : { label: "InActive", value: false }
  );

  setValue("page_type", {
    label: row?.page_type,
    value: row?.page_type,
  });

  setValue("page_content", row?.description || "");
  setValue("page_content_hn", row?.hn_description || "");

  trigger("haveSubMenu");
  trigger("page_type");

  setTimeout(() => {
    if (window.CkEditor?.page_content) {
      window.CkEditor.page_content.setData(row?.description || "");
    }

    if (window.CkEditor?.page_content_hn) {
      window.CkEditor.page_content_hn.setData(row?.hn_description || "");
    }
  }, 300);
};
  useEffect(() => {
    getMenuData();
    getVerifyDataApi();
  }, []);
  const getMenuData = () => {
    const data = {};
    getMenuListAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);
        if (status === "success") {
          const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setData(decryptedResponse);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setData([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const getVerifyDataApi = () => {
    const data = {};
    verifyAPI(data)
      .then((res) => {
        // decrypt data
        const status = decrypt(res.data.status);

        const dataVerify = decrypt(res.data?.data);
        if (status === "success") {
          const responseData = dataVerify.ck_editor;
          setIsCKEditor(responseData);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "failed") {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };


  const onFormSubmit = (data) => {
    const cleanedContent = (data.page_content || "").replace(/&nbsp;/g, " ");

    const cleanedContentHN = (data.page_content_hn || "").replace(
      /&nbsp;/g,
      " "
    );

    const body = {
      module: "Menu",

      page_title: data.page_title,
      hn_page_title: data.hn_page_title,

      menu: data.menu,
      hn_menu: data.menu_hn,

      page_type: data.page_type?.value,

      slug: data.page_url,

      order: data.order,

      status: data.status?.value,

      page_url:
        data.page_type?.value === "Link"
          ? `/links/${data.page_url.replace(/^\/+/, "")}`
          : data.page_type?.value === "Static"
            ? `/pages/${data.page_url}`
            : data.page_url,

      ...(data.page_type?.value === "Static" ||
        data.page_type?.value === "Link"
        ? {
          description: cleanedContent,
          hn_description: cleanedContentHN,
        }
        : {}),

      ...(mode === "Edit" && {
        id: watch("id"),
      }),
    };

    // console.log(body);

    // return

    const encryptedData = encrypt(body);
    const encryptData = {
      zero: encryptedData,
    };

    if (mode == "Add") {
      createMenuAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            toast.clearWaitingQueue();

            getMenuData();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === "failed") {
            setIsLoading(false);
            toast.warning(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
    }
    if (mode == "Edit") {
      updateMenuAPI(encryptData)
        .then((res) => {
          const status = decrypt(res.data.status);
          if (status == "success") {
            toast.success(res.data.message);
            getMenuData();
            setIsOpen(false);
            setIsLoading(false);
            setMode("Add");
          } else if (status === "failed") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
    }
  };

  const handlePageTypeChange = (selectedOption) => {
    setValue("page_type", selectedOption);
    trigger("page_type");
  };
  const handleStatusChange = (selectedOption) => {
    setValue("status", selectedOption);
    trigger("status");
  };
  const handleToggleStatus = (row) => {
    setValue("id", row.id);
    setValue("status", row.status);
    setSelectedRow(row);

    setShowModal(true);
  };
  const confirmStatusChange = () => {
    const data = {
      id: watch("id"),
      status: watch("status"),
    };
    const encryptData = encrypt(data);
    const encryptedData = {
      zero: encryptData,
    };
    updateMenuStatusAPI(encryptedData)
      .then((res) => {
        const status = decrypt(res.data.status);
        if (status == "success") {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setIsOpen(false);
          setShowModal(false);
          getMenuData();
          setIsLoading(false);
        } else if (status === "failed") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };
  console.log(isCKEditor, "isCKEditor");

  return (
    <>
      <Head title={"Manage Menu"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Menu"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <Card className="p-5">
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className="g-gs mb-2">
                    <Col md="2">
                      <div className="form-group">
                        <Label className="form-label">Order</Label>
                        <input
                          id="order"
                          placeholder="Enter Order"
                          type="text"
                          className="form-control"
                          {...register("order", {
                            required: false,
                            // pattern: {
                            //   value: /^[1-9][0-9]{0,2}$/,
                            //   message: "Order must be between 1 and 100",
                            // },
                          })}
                        />
                      </div>
                      {errors?.order && (
                        <span
                          className="invalid"
                          style={{
                            color: "#e85347",
                            fontSize: "11px",
                            fontStyle: "italic",
                          }}
                        >
                          {errors?.order?.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row className={`g-gs`}>
                    {/*Page Title */}
                    <Col md="4" sm="3" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="page_title">
                          {"Page Title"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter page_title"}
                            type="text"
                            id="page_title"
                            {...register("page_title", {
                              required: {
                                value: true,
                                message: "Page Title is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "page_title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "page_title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("page_title")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("page_title", e.target.value);
                              trigger("page_title"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.page_title && <span className="invalid">{errors?.page_title?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Page Title HN */}
                    <Col md="4" sm="3" xxl="6">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="hn_page_title">
                          {"Page Title Hindi"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter page title in hindi"}
                            type="text"
                            id="hn_page_title"
                            {...register("hn_page_title", {
                              required: {
                                value: true,
                                message: "Page Title Hindi is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "page title must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "page title cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("hn_page_title")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("hn_page_title", e.target.value);
                              trigger("hn_page_title"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.hn_page_title && <span className="invalid">{errors?.hn_page_title?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Menu */}
                    <Col md="4" sm="3" xxl="5">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="menu">
                          {"Menu"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter menu"}
                            type="text"
                            id="menu"
                            {...register("menu", {
                              required: {
                                value: true,
                                message: "menu is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "menu must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "menu cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("menu")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("menu", e.target.value);
                              trigger("menu"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.menu && <span className="invalid">{errors?.menu?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Menu HN */}
                    <Col md="4" sm="3" xxl="5">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="menu_hn">
                          {"Menu Hindi"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter menu in hindi"}
                            type="text"
                            id="menu_hn"
                            {...register("menu_hn", {
                              required: {
                                value: true,
                                message: "menu is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 3,
                                message: "menu must be at least 2 characters long",
                              },
                              maxLength: {
                                value: 50,
                                message: "menu cannot exceed 50 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("menu_hn")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("menu_hn", e.target.value);
                              trigger("menu_hn"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.menu_hn && <span className="invalid">{errors?.menu_hn?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Page Type */}
                    <Col md="4" sm="3" xxl="2">
                      <div className="form-group">
                        <Label className="from-label" htmlFor="page_type">
                          Page Type
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="page_type"
                            options={[
                              { value: "Link", label: "Link" },
                              { value: "Static", label: "Static" },
                              { value: "Dynamic", label: "Dynamic" },
                              { value: "Hyperlink", label: "Hyperlink" },
                            ]}
                            {...register("page_type", {
                              required: "Please select page type",
                            })}
                            onChange={handlePageTypeChange}
                            value={watch("page_type")}
                          />
                          {errors.page_type && (
                            <span
                              className="invalid"

                            >
                              {errors?.page_type?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                    {/*Page URL */}
                    <Col md="4" sm="3" xxl="10">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="page_url">
                          {"Page URL"} <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter page url"}
                            type="text"
                            id="page_url"
                            {...register("page_url", {
                              required: {
                                value: true,
                                message: "page url is required",
                              },
                              // pattern: {
                              //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
                              //   message: "Only alphabets are allowed",
                              // },
                              minLength: {
                                value: 1,
                                message: "page url must be at least 1 characters long",
                              },
                              maxLength: {
                                value: 100,
                                message: "page url cannot exceed 100 characters",
                              },
                            })}
                            className="form-control"
                            value={watch("page_url")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("page_url", e.target.value);
                              trigger("page_url"); // Trigger validation
                            }}
                          // onInput={(e) => {
                          //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                          // }}
                          />
                          {errors.page_url && <span className="invalid">{errors?.page_url?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Status */}
                    <Col md="4" sm="3" xxl="2">
                      <div className="form-group">
                        <Label className="from-label" htmlFor="status">
                          Status
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="status"
                            options={[
                              { value: true, label: "Active" },
                              { value: false, label: "InActive" },
                            ]}
                            {...register("status", {
                              required: "Please select status",
                            })}
                            onChange={handleStatusChange}
                            value={watch("status")}
                          />
                          {errors.status && (
                            <span
                              className="invalid"

                            >
                              {errors?.status?.message}
                            </span>
                          )}
                        </div>
                      </div>
                    </Col>
                    {/* CK EDITOR */}
                    {(watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && (
                      <Col md="12" sm="12" xxl="6">
                        {isCKEditor ? (
                          <>
                            {/* COMMENTED FOR AUDIT */}
                            {/* <CKEditor title={"Page Content"} id={"page"} /> */}
                            {/* <CkEditor
                              title="Page Content"
                              id="page"
                              value={watch("description")}
                              setValue={setValue}
                              name="description"
                            /> */}
                            {/* <CKEditor
                              id="page"
                              title="Page Content"
                              initialData={watch("page_content")}
                              onChange={(data) => setValue("page_content", data)}
                            /> */}
                            <CkEditor
                              id="page_content"
                              label="Page Content"
                              initialData={watch("page_content")}
                              onChange={(data) => setValue("page_content", data)}
                            />
                          </>
                        ) : (
                          <>
                            {/* REMOVE AFTER AUDIT */}
                            <Label htmlFor="page_content" className="form-label">
                              {"Page Content"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={15}
                                placeholder={"Enter page content"}
                                type="text"
                                id="page_content"
                                {...register("page_content", {
                                  required: "Page content is required",
                                  // pattern: {
                                  //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                  //   message:
                                  //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                  // },
                                })}
                                className="form-control"
                                value={watch("page_content")}
                                onChange={(e) => {
                                  setValue("page_content", e.target.value);
                                  trigger("page_content");
                                }}
                              />
                              {errors.page_content && <span className="invalid">{errors?.page_content?.message}</span>}
                            </div>
                          </>
                        )}
                      </Col>
                    )}
                    {/* CK EDITOR Hindi */}
                    {(watch("page_type")?.value == "Static" || watch("page_type")?.value == "Link") && (
                      <Col md="12" sm="12" xxl="6">
                        {isCKEditor ? (
                          <>
                            {/* COMMENTED FOR AUDIT */}
                            {/* <CKEditor title={"Page Content in Hindi"} id={"pagehn"} /> */}

                            {/* <CKEditor
                              id="pagehn"
                              title="Hindi Content"
                              initialData={watch("page_content_hn")}
                              onChange={(data) => setValue("page_content_hn", data)}
                            /> */}
                            <CkEditor
                              id="page_content_hn"
                              label="Page Content in Hindi"
                              initialData={watch("page_content_hn")}
                              onChange={(data) => setValue("page_content_hn", data)}
                            />
                          </>
                        ) : (
                          <>
                            {/* REMOVE AFTER AUDIT */}
                            <Label htmlFor="page_content_hn" className="form-label">
                              {"Page Content in Hindi"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <textarea
                                rows={15}
                                placeholder={"Enter page content in hindi"}
                                type="text"
                                id="page_content_hn"
                                {...register("page_content_hn", {
                                  required: "Page content in hindi is required",
                                  // pattern: {
                                  //   value: /^[a-zA-Z0-9.,/_( )\n\r-]+$/,
                                  //   message:
                                  //     "Only alphanumeric characters and [ , . / - _ ( )] are allowed",
                                  // },
                                })}
                                className="form-control"
                                value={watch("page_content_hn")}
                                onChange={(e) => {
                                  setValue("page_content_hn", e.target.value);
                                  trigger("page_content_hn");
                                }}
                              />
                              {errors.page_content_hn && (
                                <span className="invalid">{errors?.page_content_hn?.message}</span>
                              )}
                            </div>
                          </>
                        )}
                      </Col>
                    )}
                  </Row>
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <Button disabled={isLoading} color="primary" size="md">
                        {isLoading ? <Spinner size="sm" color="primary" /> : mode == "Add" ? "Save" : "Update"}
                      </Button>
                    </div>
                  </Col>
                </Form>
              </Card>
            )}
          </Row>
          <MyDataTable data={data} columns={column} title={"Menu"} isLoading={isLoading} sub />
        </Block>
      </Content>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("status")}
      />
    </>
  );
};

export default ManageMenu;
